import React from 'react';

// components
import Icon from '../Icon';
import Text from '../Text';

function HotBadgeV2({
  title = 'Hot offer',
  gradientColorStart,
  gradientColorEnd,
}) {
  return (
    <div className="relative">
      <Icon
        type="hot-offer-rectangle-badge"
        className="w-[48px] lg:w-[64px] h-[60px] lg:h-[80px]"
        gradientColorStart={gradientColorStart}
        gradientColorEnd={gradientColorEnd}
      />
      <div className="absolute top-1 lg:top-2 left-0 right-0 flex justify-center">
        <Icon type="gradient-circle" className="size-[16px] lg:size-[28px]" />
      </div>
      <Text
        type="paragraph"
        className="text-center text-10 lg:text-12 font-bold leading-14 lg:leading-16 tracking-[0.24px] uppercase absolute bottom-[9px] left-1/2 translate-x-[-50%] text-richcarmine"
      >
        {title}
      </Text>
    </div>
  );
}

export default HotBadgeV2;
